import React, {PropTypes, Component} from 'react';
import Button from '../../../common/components/Button';
import Modal from '../../../common/components/Modal';
import TextArea from '../../../common/components/c_TextArea';

export default function EditGuide(props) {

  return (
    <Modal
      onClickOut={props.onClose}>
      <div className='guide-modal'>
        <TextArea
          data-id='edit-textarea'
          value={props.source}
          onChange={props.onUpdate}
        />
        <Button
         data-id='save-guide'
         className='button-main'
         label='Save'
         onClick={props.onSave}
        />
      </div>
    </Modal>
  );

}



// WEBPACK FOOTER //
// ./shared/react/admin/Guide/edit.js